/**
 * Visibilidad del botón "Contabilización masiva" en la vista clásica.
 *
 * Regla de negocio (2026-08-14):
 *  - Requiere permiso de contabilizar: rol global O efectivo de la carpeta
 *    (el efectivo ya incluye el rol global como piso vía permission_engine,
 *    pero se consultan ambos para no depender de ese detalle).
 *  - Requiere que la carpeta tenga archivos DIRECTOS: el modal empareja
 *    contables contra los documentos de la carpeta, sin bajar a subcarpetas.
 *  - Carpeta CERRADA: bloquea a todos MENOS a root/contador (level 'all'),
 *    igual que el resto de acciones de escritura del mismo header.
 *
 * Por qué el escape de root importa: contabilizar UN archivo en carpeta
 * cerrada ya está permitido a root/contador (file.js:791,865 usan
 * `!isClosing || isRoot`), y "Carga masiva" también (list_folders.js:648).
 * Sin el escape, el botón que hace en lote exactamente esa misma acción
 * desaparecía justo en las carpetas cerradas — que son la mayoría en
 * producción — y como los cierres son por empresa, el botón parecía
 * aparecer en unas empresas y en otras no.
 *
 * Módulo puro: sin React/Redux/Firestore, para poder testearlo directo.
 */

/**
 * @param {object}  params
 * @param {object}  params.globalRole      roles.documents del rol global
 * @param {object}  params.effective       matriz efectiva de la carpeta (.documents)
 * @param {boolean} params.isSuperAdmin    level === 'all' (root/contador)
 * @param {boolean} params.isClosed        la carpeta está cerrada
 * @param {boolean} params.hasDirectFiles  la carpeta lista archivos propios
 * @returns {boolean}
 */
export const canSeeBulkAccounting = ({
  globalRole,
  effective,
  isSuperAdmin,
  isClosed,
  hasDirectFiles,
} = {}) => {
  if (!hasDirectFiles) return false;
  if (isClosed && !isSuperAdmin) return false;
  return !!globalRole?.accounting || !!effective?.accounting;
};

export default canSeeBulkAccounting;
